import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from 'app/store';
import Theme from 'components/template/Theme';
import 'locales';

const AppProviders = ({ children }) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Theme>{children}</Theme>
      </PersistGate>
    </Provider>
  );
};

export default AppProviders;
